export default __webpack_public_path__ + "static/media/iconmonstr-video-1.d7bc9460.svg";